import { createReducer, on } from '@ngrx/store';
import { zefResetState } from '@zerops/zef/core';
import {
  clearPromoCodeRedemption,
  clearSubmittedPromoCode,
  loadPromoCodeRedemptionsSuccess,
  promoCodeFlowResolved,
  promoCodeSubmittedWithSignup,
  PromoCodeBaseActionUnion,
  redeemPromoCodeSuccess
} from './promo-code-base.action';
import { PromoCodeBaseState } from './promo-code-base.model';

const initialState = new PromoCodeBaseState();

const actionReducer = createReducer(
  initialState,
  on(
    loadPromoCodeRedemptionsSuccess,
    (s, { data }): PromoCodeBaseState => ({
      ...s,
      redemptions: data.list
    })
  ),
  on(
    redeemPromoCodeSuccess,
    (s, { data }): PromoCodeBaseState => ({
      ...s,
      lastRedemption: data
    })
  ),
  on(
    clearPromoCodeRedemption,
    (s): PromoCodeBaseState => ({
      ...s,
      lastRedemption: undefined
    })
  ),
  on(
    promoCodeSubmittedWithSignup,
    (s, { code }): PromoCodeBaseState => ({
      ...s,
      submitted: { code }
    })
  ),
  on(
    promoCodeFlowResolved,
    (s, { code, appliesToTopUp }): PromoCodeBaseState => ({
      ...s,
      resolvedFlow: { code, appliesToTopUp }
    })
  ),
  on(
    clearSubmittedPromoCode,
    (s): PromoCodeBaseState => ({
      ...s,
      submitted: undefined
    })
  ),
  // Cleared with everything else on an auth clear (logout, cross-tab
  // invalidation). Carrying `submitted` across would let one session's code be
  // announced into the next one's.
  on(zefResetState, () => initialState)
);

export function promoCodeBaseReducer(
  state: PromoCodeBaseState,
  action: PromoCodeBaseActionUnion
) {
  return actionReducer(state, action);
}
